import { ref, defineComponent, onMounted, PropType, watch } from 'vue';
import { useAuth } from '@/store/auth.store';
import { useEnvStore } from '@/store/env.store';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { setTimezone } from '@marfa/bo-utils';
import { PARENT_ROUTE_NAMES } from '@/models/common/env.model';
import { DASHBOARD_ROUTE_NAME } from '@/router/routes/routes';

export default defineComponent({
  name: 'Root',
  props: {
    wlSlug: {
      type: String,
      required: true,
    },
    whitelabelId: {
      type: String,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    dashboardPermissions: {
      type: String,
      default: '',
    },
    currentParentRouteName: {
      type: String as PropType<PARENT_ROUTE_NAMES>,
      default: '',
    },
    multibrandApiUrl: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const { token } = storeToRefs(useAuth());
    const root = ref();
    const { setEnv } = useEnvStore();
    const router = useRouter();

    onMounted(() => {
      if (!token.value) {
        router.push({ name: DASHBOARD_ROUTE_NAME });
      }

      setEnv(props);

      const timezone = localStorage.getItem('adminTimezone');

      if (timezone) {
        setTimezone(timezone);
      }
    });

    watch(props, (updatedProps) => {
      setEnv(updatedProps);
    });

    return {
      root,
    };
  },
});
